import { Select, SelectProps } from "antd";
import clsx from "clsx";
import Icon from "@ant-design/icons";
import { FaChevronDown } from "react-icons/fa";
import styles from "./styles/base-select.module.scss";

interface Props extends SelectProps {

}

const BaseSelect = ({ className, ...rest }: Props) => {
    return (
        <Select
            suffixIcon={<Icon component={FaChevronDown} />}
            className={clsx(className, styles.select)}
            {...rest}
        />
    );
};

export default BaseSelect;